export const css = {
	root: 'j3fhS_3J',
	pressed: '_1pDGd35N',
	disabled: '_3QS4Hwss',
	label: '_3DbId7LI',
	' _key': 'certwise-theme/certwise/dojo/button'
};

export default css;
